import { useAskAiContext } from "../contexts/AskAiContext";

export const useAskAi = () => useAskAiContext();

export default useAskAi;
